/**
 * Shared money formatter for the user web app.
 *
 * Use this everywhere a price is displayed. Never hard-code symbols.
 */

const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  INR: '₹',
  AED: 'د.إ',
  SAR: 'ر.س',
  KWD: 'د.ك',
  QAR: 'ر.ق',
  BHD: 'د.ب',
  OMR: 'ر.ع',
  PKR: '₨',
  BDT: '৳',
  LKR: 'රු',
  NPR: 'रू',
  PHP: '₱',
};

const THREE_DECIMAL_CURRENCIES = new Set(['KWD', 'BHD', 'OMR']);

function lookupSymbol(code) {
  if (!code) return '';
  return CURRENCY_SYMBOLS[code.toUpperCase()] || code.toUpperCase();
}

export function formatMoney(value, options = {}) {
  if (value === null || value === undefined) return '';

  let amount;
  let symbol;
  let decimals = options.decimals ?? 2;
  let baseAmount;
  let baseSymbol;

  if (typeof value === 'number') {
    amount = value;
    symbol = options.symbol ?? lookupSymbol(options.currency);
  } else {
    amount = value.amount ?? 0;
    const currencyCode = (value.currency ?? options.currency)?.toUpperCase();
    symbol = value.symbol ?? options.symbol ?? lookupSymbol(currencyCode);
    decimals = options.decimals ?? (currencyCode && THREE_DECIMAL_CURRENCIES.has(currencyCode) ? 3 : 2);
    baseAmount = value.amountInBase;
    baseSymbol = value.baseSymbol ?? lookupSymbol(value.baseCurrency);
  }

  const formattedAmount = Number(amount).toFixed(decimals);

  // Default to symbol-after-amount across the product.
  const position = options.symbolPosition ?? 'suffix';
  const formatted = position === 'prefix' || !symbol
    ? `${symbol}${formattedAmount}`
    : `${formattedAmount} ${symbol}`;

  if (options.showBase && baseAmount != null && baseAmount !== amount) {
    return `${formatted} (${baseSymbol}${Number(baseAmount).toFixed(2)})`;
  }

  return formatted;
}
